import React from "react";
import { getMediaUrl } from "../../lib/utils";

const CommentPhoto = ({ content }) => {
  if (!content) return null;

  return (
    <div className="mt-2 w-fit max-w-full overflow-hidden rounded-xl border border-gray-100 bg-gray-50">
      <img src={getMediaUrl(content)} alt="Comment" className="block max-h-[260px] max-w-full object-contain sm:max-w-[320px]" loading="lazy" />
    </div>
  );
};

export default CommentPhoto;